// 可用的年份範圍（開發者可在此修改）
// 此常數用於所有需要年份選擇的頁面：
// - 申請假期 (LeaveApplication)
// - 假期餘額 (LeaveBalance)
// - 部門群組假期餘額 (DepartmentGroupBalances)
// - Paper Flow假期申請 (AdminPaperFlow)
// - 假期餘額管理 (AdminBalances)

export const AVAILABLE_YEARS = [2023, 2024, 2025, 2026];

